import * as RadixDialog from '@radix-ui/react-dialog';
import React, { forwardRef, ReactNode } from 'react';

import { isKnownExternalTool } from '@/lib/utils/dialog-interactions';
import { cn } from '@/lib/utils/tailwind';

type DialogContentProps = Omit<RadixDialog.DialogContentProps, 'asChild'> & {
  children: ReactNode;
  className?: string;
  onInteractOutside?: (event: Event) => void;
};

const DialogContent = forwardRef<HTMLDivElement, DialogContentProps>(
  ({ children, className, onInteractOutside, ...props }, ref) => (
    <RadixDialog.Content
      className={cn('z-50 focus:outline-none', className)}
      ref={ref}
      onInteractOutside={event => {
        const target = event?.target as HTMLElement | null;

        if (isKnownExternalTool(target)) {
          event.preventDefault();
        }
        onInteractOutside?.(event);
      }}
      {...props}
    >
      {children}
    </RadixDialog.Content>
  ),
);
DialogContent.displayName = 'DialogContent';

export { DialogContent, type DialogContentProps };
